import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { AuthSelectComponent, AuthSelectOption } from "../auth-select/auth-select.component";
import { I18nService, Lang } from "../../i18n/i18n.service";

/**
 * Selector de idioma de las pantallas de auth.
 *
 * Sustituye al antiguo `app-select-country`, que no cambiaba el idioma sino que
 * redirigía a otro despliegue (app.dexfreight.io), y que usaba un overlay de
 * Material que se recortaba en pantallas angostas. Aquí el panel se renderiza
 * dentro del documento vía `dxc-auth-select`, así que siempre se ve completo.
 */
@Component({
  standalone: true,
  selector: 'dxc-language-select',
  imports: [AuthSelectComponent],
  template: `
    <dxc-auth-select
      variant="pill"
      align="right"
      [options]="options()"
      [value]="i18n.lang()"
      [ariaLabel]="i18n.t('lang.label')"
      (valueChange)="onChange($event)">
    </dxc-auth-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectComponent {

  readonly i18n = inject(I18nService);

  readonly options = computed<AuthSelectOption[]>(() => [
    { value: 'es', label: this.i18n.t('lang.es'), icon: 'dxf_flag_mx' },
    { value: 'en', label: this.i18n.t('lang.en'), icon: 'dxf_flag_us' }
  ]);

  onChange(value: string) { this.i18n.setLang(value as Lang); }
}
